import { gql, useSubscription } from '@apollo/client';
import { DexieIndexedDb } from '@cnx-saas/indexed-db';

const TOPIC_SUBSCRIPTION = gql`
  subscription ebtopic($topic: String!) {
    ebtopic(topic: $topic)
  }
`;

export function useTopicSubscriptions() {
  useSubscription(TOPIC_SUBSCRIPTION, {
    variables: { topic: 'pushToTenant:*' },
    onSubscriptionData: async ({ subscriptionData }) => {
      const payload = subscriptionData.data?.ebtopic?.payload;

      if (payload) {
        const pushEvent = {
          id: payload.__id,
          type: payload.__type,
          navigationLinkPathParams: payload.__navigationLinkPathParams,
          navigationLinkQueryParams: payload.__navigationLinkQueryParams,
          message: payload.__message,
          payload: payload,
          timestamp: new Date(Date.now()),
        };

        await DexieIndexedDb.getInstance().addPushEvent(pushEvent);
      }
    },
  });
}
